export enum PermissionAction {
  READ = 'Ler',
  INSERT = 'Inserir',
  UPDATE = 'Atualizar',
  DELETE = 'Excluir',
  EVALUATE = 'Avaliar',
  APROVE = 'Aprovar',
  EXECUTE = 'Executar'
}

export enum PermissionResource {
  ACCOUNT = 'Account',
  ACCESSORY = 'Acessorio',
  BREAKDOWN = 'Avaria',
  CATEGORY = 'Categoria',
  COST_CENTER = 'CentroResultado',
  CITY = 'Cidade',
  DEALERSHIP = 'Concessionaria',
  BOARD = 'Diretoria',
  APPRAISAL_COMPANY = 'EmpresaAvaliadora',
  ADDRESS = 'Endereco',
  STATE = 'Estado',
  ITEM_SERIES = 'ItemSerie',
  BRAND = 'Marca',
  MODEL = 'Modelo',
  PRECIFICATION = 'Precificacao',
  PREPARATION = 'Preparacao',
  PROVIDER = 'Prestador',
  PRODUCT = 'Produto',
  OWNER = 'Proprietario',
  SERVICE = 'Servico',
  SLA = 'SLA',
  UNIT_MEASURE = 'UnidadeMedida',
  USER = 'Usuario',
  VEHICLE = 'Veiculo',
  INSPECTION_ACCESSORY = 'VistoriaAcessorio',
  INSPECTION_BREAKDOWN = 'VistoriaAvaria',
  INSPECTION = 'Vistoria',
  INSPECTION_CR_HISTORY = 'VistoriaHistoricoCR',
  INSPECTION_PHOTO = 'VistoriaFoto',
  INSPECTION_ITEM_SERIES = 'VistoriaItemSerie',
  INSPECTION_REPORT = 'VistoriaLaudo',
  DASHBOARD = 'Dashboard',
  MANAGEMENT_ANALYSIS = 'AnaliseGerencial',
  DASHBOARD_MANAGEMENT_ANALYSIS = 'DashboardAnaliseGerencial',
  REFUND = 'Reembolso',
  INSPECTION_CATEGORY = 'CategoriaVistoria',
  INSPECTION_PHOTO_PARAMETRIZATION = 'ParametrizacaoFotosVistoria',
  TCO_CATEGORY = 'CategoriaTco',
  FILE_MANAGER = 'GerenciadorArquivo',
  CATEGORY_GROUP = 'GrupoCategoria',
  PHOTO_FLOW_PARAMETRIZATION = 'ParametrizacaoFluxoFotos',
  PHOTO_SECTION_PARAMETRIZATION = 'ParametrizacaoSecaoFoto',
  EVALUATION_TYPE_PARAMETRIZATION = 'ParametrizacaoTipoAvaliacao',
  INSPECTION_PARAMETRIZATION = 'ParametrizacaoVistoria',
  PROFILE = 'Perfil',
  VALOR_RESIDUAL = 'ValorResidual',
  INTEGRACOES = 'Integracoes',
  MARGEM = 'Margem',
  INSPECTION_BACKOFFICE = 'VistoriaBackOffice'
}

export type ResourceToken = {
  [K in string]?: PermissionAction[]
}

export interface UserPermissions {
  role: string
  resources: ResourceToken
}

export type PermissionCheck = {
  resource: PermissionResource
  action?: PermissionAction
}
